import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRouteFilters: {},
  selectedStopFilters: {},
};

const filterPanelSlice = createSlice({
  name: 'filterPanel',
  initialState,
  reducers: {
    setRouteFilters(state, action) {
      state.selectedRouteFilters = { ...action.payload };
    },
    clearRouteFilters(state) {
      state.selectedRouteFilters = {};
    },
    setStopFilters(state, action) {
      state.selectedStopFilters = { ...action.payload };
    },
    clearStopFilters(state) {
      state.selectedStopFilters = {};
    },
  },
});

export const {
  setRouteFilters,
  clearRouteFilters,
  setStopFilters,
  clearStopFilters,
} = filterPanelSlice.actions;

export default filterPanelSlice.reducer;
